import React from 'react';
import styled from 'styled-components';
import MenuLink from './MenuLink';
import AccordionMenu from 'components/shared/AccordionMenu';
import classnames from 'classnames';

const ListOfLinksContainer = styled.div`
  & > h3 {
    font-family: 'Whitney Bold', Arial, sans-serif;
    font-size: 1rem;
    font-weight: 700;
    color: #fff;
    line-height: 1.2;
    margin-bottom: 0.375rem;
  }

  & > h2 {
    font-family: 'Whitney Bold', Arial, sans-serif;
    font-size: 1rem;
    font-weight: 700;
    text-transform: uppercase;
    color: #fff;
    margin-bottom: 0.9375rem;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.2);
  }

  & > ul > li > a {
    font-size: 1rem;
    font-weight: 400;
    color: #fff;
    line-height: 1.2;
    text-decoration: none;
    margin-bottom: 0.3125rem;
    padding-top: 1px;
    padding-bottom: 1px;
  }

  margin-bottom: 1.0625rem;
`;

const ListOfLinks = ({ children }) => (
  <ListOfLinksContainer>{children}</ListOfLinksContainer>
);

const StyledDiv = styled.div`
  & li.accordion-component-item {
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.2);
  }

  .accordion-component-body {
    padding-left: 1.5625rem;
  }
`;

const ShopContent = () => (
  <>
    <ListOfLinks>
      <h3 className="category-header">Formulas for Horses</h3>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/health-categories"
            className="category-link"
          >
            See All Supplements
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Wellness Foundation Formulas</h3>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/platinum-performance-equine/GCANEPLIG.html"
            className="category-link"
          >
            Platinum Performance® Equine
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Other Popular Formulas</h3>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/bio-sponge/GCANEBIO.html"
            className="category-link"
          >
            Bio-Sponge®
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/platinum-balance/GCANEBALP.html"
            className="category-link"
          >
            Platinum Balance<sup>™</sup>
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/healthy-weight/GCANEHEAL.html"
            className="category-link"
          >
            Healthy Weight Oil
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/platinum-hoof-support/GCANEHOOP.html"
            className="category-link"
          >
            Platinum Hoof Support
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/platinum-metabolic-support/GCANEMETP.html"
            className="category-link"
          >
            Platinum Metabolic Support
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/platinum-joint-care-plus-ha/GCANEOH2P.html"
            className="category-link"
          >
            Platinum Joint Care + HA
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/platinum-vitamin-e/GCANEVIEP.html"
            className="category-link"
          >
            Platinum Vitamin E
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/osteon/GCANEOSTP.html"
            className="category-link"
          >
            Osteon<sup>®</sup>
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-header">Health Categories</h2>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/health-categories"
            className="category-link"
          >
            See All Categories
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/health-categories/horse-overall-wellness-supplements"
            className="category-link"
          >
            Overall Health
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/health-categories/horse-antioxidants"
            className="category-link"
          >
            Antioxidant Support
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/health-categories/horse-bone-health"
            className="category-link"
          >
            Bone &amp; Tendon Health
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/health-categories/horse-coat-health"
            className="category-link"
          >
            Coat Health
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/health-categories/horse-digestive-health"
            className="category-link"
          >
            Digestion
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/health-categories/horse-electrolyte"
            className="category-link"
          >
            Electrolytes
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/health-categories/horse-hoof-supplements"
            className="category-link"
          >
            Hoof Care
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/health-categories/horse-joint-supplements"
            className="category-link"
          >
            Joint Support
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/health-categories/horse-metabolic"
            className="category-link"
          >
            Metabolic Support
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/health-categories/horse-neurologic-support"
            className="category-link"
          >
            Neurologic Support
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/health-categories/horse-strength-recovery"
            className="category-link"
          >
            Performance &amp; Recovery
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/health-categories/horse-reproduction-fertility"
            className="category-link"
          >
            Reproduction &amp; Fertility
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/health-categories/horse-allergy-supplements"
            className="category-link"
          >
            Skin &amp; Seasonal Allergies
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/health-categories/horse-weight-gain"
            className="category-link"
          >
            Weight Management
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-header">Now Available in Canada</h2>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/platinum-dermal-support/GCANESKIP.html"
            className="category-link"
          >
            Platinum Dermal Support
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/platinum-electrolyte-plus/GCANEELEP.html"
            className="category-link"
          >
            Platinum Electrolyte Plus
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/platinum-gastric-support/GCANEPGAP.html"
            className="category-link"
          >
            Platinum Gastric Support
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/platinum-motility/GCANEMOTP.html"
            className="category-link"
          >
            Platinum Motility
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/platinum-muscle-support/GCANERENP.html"
            className="category-link"
          >
            Platinum Muscle Support
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/platinum-poise/GCANESTEP.html"
            className="category-link"
          >
            Platinum Poise
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/platinum-stallion-support/GCANEPOTP.html"
            className="category-link"
          >
            Platinum Stallion Support
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/platinum-vitamin-e/GCANEVIEP.html"
            className="category-link"
          >
            Platinum Vitamin E
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-header">Auto-Ship</h2>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/auto-ship.html"
            className="category-link"
          >
            Auto-Ship FAQ
          </a>
        </li>
      </ul>
    </ListOfLinks>
  </>
);

const WellnessContent = () => (
  <>
    <ListOfLinks>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/one-bucket-approach"
            className="category-link"
          >
            The One Bucket Approach
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Daily Wellness Formula</h3>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/horses-wellness"
            className="category-link"
          >
            Platinum Performance® Equine
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-header">All Formulas For Horses</h2>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/health-categories"
            className="category-link"
          >
            See All Supplements
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-header">Platinum Magazine</h2>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/all-articles.html"
            className="category-link"
          >
            All Articles
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/articles.html"
            className="category-link"
          >
            Latest Issue
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Horse Care</h3>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/articles/horse-care.html"
            className="category-link"
          >
            How to Attend to a New Horse
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-header">Results</h2>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/horses-supplement-reviews.html"
            className="category-link"
          >
            Success Stories &amp; Reviews
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/tellusaboutyourhorse-canada.html"
            className="category-link"
          >
            Share Your Success Story
          </a>
        </li>
      </ul>
    </ListOfLinks>
  </>
);

const PerformanceContent = ({ platinumEcomBaseUrl }) => (
  <>
    <ListOfLinks>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/performance-horse"
            className="category-link"
          >
            Supplementing for Performance
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-header">Results</h2>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/horses-supplement-reviews.html"
            className="category-link"
          >
            Success Stories &amp; Reviews
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/tellusaboutyourhorse-canada.html"
            className="category-link"
          >
            Share Your Success Story
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-header">Resources For Riders</h2>
      <h3 className="category-header">Show Safe Formulas</h3>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/performance-horse/peace-of-mind-for-competition"
            className="category-link"
          >
            Supplements Safe for Sport
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Platinum Team Riders</h3>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/horses-platinum-ambassadors-athletes.html"
            className="category-link"
          >
            See What Formulas the Team Uses
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Body Condition Score</h3>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/body-condition-score.html"
            className="category-link"
          >
            How to Score Your Horse
          </a>
        </li>
      </ul>
    </ListOfLinks>
  </>
);

const ConditionsContent = () => (
  <>
    <ListOfLinks>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/horse-conditions"
            className="category-link"
          >
            See All Conditions
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/horse-conditions/horse-allergy-support"
            className="category-link"
          >
            Allergies
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/horse-conditions/horse-bone-health"
            className="category-link"
          >
            Bone Health
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/horse-conditions/horse-digestive-health"
            className="category-link"
          >
            Digestive Health
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/horse-conditions/horse-hoof-supplements"
            className="category-link"
          >
            Hoof Care
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/horse-conditions/horse-joint-supplements"
            className="category-link"
          >
            Joint Health
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/horse-conditions/horse-metabolic"
            className="category-link"
          >
            Metabolic Support
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/horse-conditions/horse-reproduction-fertility"
            className="category-link"
          >
            Reproduction
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/horse-conditions/horse-weight-gain-and-management"
            className="category-link"
          >
            Weight Management
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-header">Supplementing for Health</h2>
      <h3 className="category-header">Daily Wellness Formula</h3>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/platinum-performance-equine/GCANEPLIG.html"
            className="category-link"
          >
            Platinum Performance® Equine
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/health-categories"
            className="category-link"
          >
            See All Supplements
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-header">Results</h2>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/horses-supplement-reviews.html"
            className="category-link"
          >
            Success Stories &amp; Reviews
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/tellusaboutyourhorse-canada.html"
            className="category-link"
          >
            Share Your Success Story
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-header">Resources</h2>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/body-condition-score.html"
            className="category-link"
          >
            Body Condition Score
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/articles/horse-care.html"
            className="category-link"
          >
            Horse Care
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/articles.html"
            className="category-link"
          >
            Platinum Magazine
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/podcasts.html"
            className="category-link"
          >
            Platinum Podcast
          </a>
        </li>
      </ul>
    </ListOfLinks>
  </>
);

const VeterinariansContent = () => (
  <>
    <ListOfLinks>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/horses-veterinarians-ca.html"
            className="category-link"
          >
            Nutrition in Your Practice
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/research.html"
            className="category-link"
          >
            Nutritional Research
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/veterinary-student-advancement-program.html"
            className="category-link"
          >
            Platinum Veterinary Student Program
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-header">Veterinary Heritage</h2>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/our-story.html"
            className="category-link"
          >
            The Platinum Heritage
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/platinum-advisors.html"
            className="category-link"
          >
            Meet The Team
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-header">Platinum Summit</h2>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/ca-platinum-summit.html"
            className="category-link"
          >
            Platinum Summit 2022
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-header">Online Lectures</h2>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/on-demand-ce-lectures-ca.html"
            className="category-link"
          >
            All On Demand Lectures
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/platinumsummit-2019-videos.html"
            className="category-link"
          >
            View Summit Videos
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h2 className="category-header">Results</h2>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/veterinarian-reviews.html"
            className="category-link"
          >
            Reviews by Veterinarians
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Refer a Friend</h3>
      <ul className="category-links-list">
        <li>
          <a
            href={`${platinumEcomBaseUrl}/referafriendweb`}
            className="category-link"
          >
            Give $20, Get $20
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <ul className="category-links-list">
        <li>
          <a
            href="https://www.platinumperformance.ca/login"
            className="category-link font-weight-bold"
          >
            Log In/Register
          </a>
        </li>
      </ul>
    </ListOfLinks>
  </>
);

const InsidePlatinumContent = () => (
  <>
    <ListOfLinks>
      <h3 className="category-header">Magazine</h3>
      <ul>
        <li>
          <a href="https://www.platinumperformance.ca/articles.html">
            Latest Issue
          </a>
        </li>
        <li>
          <a href="https://www.platinumperformance.ca/all-articles.html">
            All Articles
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Science</h3>
      <ul>
        <li>
          <a href="https://www.platinumperformance.ca/research.html">
            Nutritional Research
          </a>
        </li>
        <li>
          <a href="https://www.platinumperformance.ca/body-condition-score.html">
            Body Condition Scoring
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Quality</h3>
      <ul>
        <li>
          <a href="https://www.platinumperformance.ca/quality.html">
            Why Quality Matters
          </a>
        </li>
        <li>
          <a href="https://www.platinumperformance.ca/articles/the-extra-mile.html">
            The Extra Mile
          </a>
        </li>
        <li>
          <a href="https://www.platinumperformance.ca/horses/performance-horse/peace-of-mind-for-competition">
            Supplements Safe for Sport
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">Results</h3>
      <ul>
        <li>
          <a href="https://www.platinumperformance.ca/satisfaction-guaranteed.html">
            100% Satisfaction Guarantee
          </a>
        </li>
        <li>
          <a href="https://www.platinumperformance.ca/horses-supplement-reviews.html">
            Client Stories &amp; Reviews
          </a>
        </li>
        <li>
          <a href="https://www.platinumperformance.ca/veterinarian-reviews.html">
            Reviews by Veterinarians
          </a>
        </li>
        <li>
          <a
            href="https://www.platinumperformance.ca/horses/tellusaboutyourhorse-canada.html"
            className="category-link"
          >
            Share Your Horse's Story
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">About Us</h3>
      <ul>
        <li>
          <a href="https://www.platinumperformance.ca/horses/our-story.html">
            The Platinum Heritage
          </a>
        </li>
        <li>
          <a href="https://www.platinumperformance.ca/platinum-advisors.html">
            Meet The Team
          </a>
        </li>
        <li>
          <a href="https://www.platinumperformance.ca/articles/limitless.html">
            Platinum Performance &amp; Zoetis
          </a>
        </li>
      </ul>
    </ListOfLinks>
    <ListOfLinks>
      <h3 className="category-header">FAQs</h3>
      <ul>
        <li>
          <a href="https://www.platinumperformance.ca/platinum-advisors.html">
            Have Questions?
          </a>
        </li>
        <li>
          <a href="https://www.platinumperformance.ca/auto-ship.html">
            Auto-Ship Delivery Program
          </a>
        </li>
        <li>
          <a href="https://www.platinumperformance.ca/horses-shipping-information.html">
            Shipping &amp; Transit
          </a>
        </li>
        <li>
          <a href="https://www.platinumperformance.ca/horses-faq.html">FAQs</a>
        </li>
      </ul>
    </ListOfLinks>
  </>
);
export default class MenuLinksCa extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props,
    };
  }

  render() {
    const { show } = this.props;
    return (
      <StyledDiv className={`mobile-menu${show ? ' show' : ''}`}>
        <ul className="nav navbar-nav" role="menu">
          <li className="nav-item" role="menuitem">
            <a
              href="https://www.platinumperformance.ca/horses"
              role="button"
              className="nav-link active"
            >
              Horses
            </a>
            <div className="header-nav-subcategory">
              <AccordionMenu>
                <AccordionMenu.Item>
                  <AccordionMenu.ItemHeader>
                    <a className="main-nav-link">Shop</a>
                  </AccordionMenu.ItemHeader>
                  <AccordionMenu.ItemBody>
                    <ShopContent />
                  </AccordionMenu.ItemBody>
                </AccordionMenu.Item>
                <AccordionMenu.Item>
                  <AccordionMenu.ItemHeader>
                    <a className="main-nav-link">Wellness</a>
                  </AccordionMenu.ItemHeader>
                  <AccordionMenu.ItemBody>
                    <WellnessContent />
                  </AccordionMenu.ItemBody>
                </AccordionMenu.Item>
                <AccordionMenu.Item>
                  <AccordionMenu.ItemHeader>
                    <a className="main-nav-link">Performance</a>
                  </AccordionMenu.ItemHeader>
                  <AccordionMenu.ItemBody>
                    <PerformanceContent
                      platinumEcomBaseUrl={this.props.platinumEcomBaseUrl}
                    />
                  </AccordionMenu.ItemBody>
                </AccordionMenu.Item>
                <AccordionMenu.Item>
                  <AccordionMenu.ItemHeader>
                    <a className="main-nav-link">Conditions</a>
                  </AccordionMenu.ItemHeader>
                  <AccordionMenu.ItemBody>
                    <ConditionsContent />
                  </AccordionMenu.ItemBody>
                </AccordionMenu.Item>
                <AccordionMenu.Item>
                  <AccordionMenu.ItemHeader>
                    <a className="main-nav-link">Veterinarians</a>
                  </AccordionMenu.ItemHeader>
                  <AccordionMenu.ItemBody>
                    <VeterinariansContent />
                  </AccordionMenu.ItemBody>
                </AccordionMenu.Item>
                <AccordionMenu.Item>
                  <AccordionMenu.ItemHeader>
                    <a className="main-nav-link">Inside Platinum</a>
                  </AccordionMenu.ItemHeader>
                  <AccordionMenu.ItemBody>
                    <InsidePlatinumContent />
                  </AccordionMenu.ItemBody>
                </AccordionMenu.Item>
              </AccordionMenu>
            </div>
          </li>
        </ul>
      </StyledDiv>
    );
  }
}
